export const TransactionData = [
    {
        id: 1,
        img: require('../../../assets/images/dashboard/transaction/1.png'),
        name: 'Nike Sports NK',
        subTitle: 'Free delivery',
        date: '12 May 2023',
        time: 'In 6 Days',
        income: '+$456',
        progress: '65%',
        status: 'Paypal',
        class:'progress-bg-success'
    },
    {
        id: 2,
        img: require('../../../assets/images/dashboard/transaction/2.png'),
        name: 'Women Bag',
        subTitle: '₹83.65 delivery',
        date: '06 May 2023',
        time: 'In 5 Days',
        income: '-$80',
        progress: '45%',
        status: 'Credit Card',
        class:'progress-bg-warning'
    },
    {
        id: 3,
        img: require('../../../assets/images/dashboard/transaction/3.png'),
        name: 'Sunglasses',
        subTitle: 'Free delivery',
        date: '28 Sep 2023',
        time: 'in 4 Months',
        income: '-$4,232',
        progress: '85%',
        status: 'Paypal',
        class:'progress-bg-danger'
    },
    {
        id: 4,
        img: require('../../../assets/images/dashboard/transaction/4.png'),
        name: 'Cotton T-shirt',
        subTitle: '₹283.65 delivery',
        date: '22 Mar 2023',
        time: 'In 8 Days',
        income: '-$645',
        progress: '75%',
        status: 'Credit Card',
        class:'progress-bg-info'
    },
];

export const ActivityData = [
    {
        id: 1,
        img: require('../../../assets/images/dashboard/activity/1.jpg'),
        title: 'Review request jim Smith',
        para: 'jan 03 19 12:25 PM at Tame',
        time:'14m Ago'
    },
    {
        id: 2,
        img: require('../../../assets/images/dashboard/activity/2.jpg'),
        title: 'New contact added',
        para: 'jan 02 19 03:10 PM at Fresno',
        time:'22m Ago'
    },
    {
        id: 3,
        img: require('../../../assets/images/dashboard/activity/3.jpg'),
        title: 'Sent review (504)236-7302',
        para: 'jan 02 19 07:35 PM at Iris',
        time:'30m Ago'
    }
]

export const SocialData = [
    {
        id: 1,
        img: require('../../../assets/images/dashboard/social-media/fb.png'),
        title: 'Facebook',
        para: 'Social Media',
        growth: '3.7%',
        price: '$24,000',
        Links: 'https://facebook.com/'
    },
    {
        id: 2,
        img: require('../../../assets/images/dashboard/social-media/insta.png'),
        title: 'Instagram',
        para: 'Social Media',
        growth: '3.7%',
        price: '$33,000',
        Links: 'https://www.instagram.com/'
    },
    {
        id: 3,
        img: require('../../../assets/images/dashboard/social-media/twit.png'),
        title: 'Twitter',
        para: 'Social Media',
        growth: '7.6%',
        price: '$72,000',
        Links: 'https://twitter.com/'
    },
]
